import styled from "styled-components";
import { MainInner, StyledMainSection } from "@/styles/global";

type StyleProps = {
  $textPosition: "left" | "right";
};

const Section = styled(StyledMainSection)``;

const Background = styled.div<StyleProps>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.black};

    ${({ $textPosition }) =>
      $textPosition === "left" ? "left: 0;" : "right: 0;"}
  }
`;
const Wrapper = styled(MainInner)`
  position: relative;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0;
  }
`;

const ScrollBlock = styled.div<StyleProps>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: calc(88px * 2);
    ${({ $textPosition }) =>
      $textPosition === "left" &&
      `
        direction: rtl;
      `};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black};
  padding: 48px 0;

  &::after {
    content: "";
    position: sticky;
    position: -webkit-sticky;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 60px;
    margin-top: -60px;
    background: linear-gradient(180deg, #21212100 0%, #212121 100%);
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    background-color: transparent;

    &::after {
      height: 100px;
      margin-top: 0;
    }

    &::before {
      content: "";
      position: sticky;
      position: -webkit-sticky;
      top: 70px;
      left: 0;
      right: 0;
      height: 100px;
      background: linear-gradient(180deg, #212121 0%, #21212100 100%);
    }
  }
`;
const StickyImageWrapper = styled.div<{ $margin?: boolean }>`
  position: sticky;
  position: -webkit-sticky;
  top: 50px;
  margin-bottom: ${({ $margin }) => ($margin ? "50vh" : "0")};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 24px 16px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  max-height: 50vh;
  display: flex;
  z-index: 1;
  width: 100%;

  &::after {
    content: "";
    position: absolute;
    bottom: -60px;
    left: 0;
    right: 0;
    height: 60px;
    z-index: 100000000;
    background: linear-gradient(180deg, #212121 0%, #21212100 100%);
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 35px;
    max-height: unset;
    height: 100vh;
    margin: unset;

    &::after {
      display: none;
      content: none;
    }
  }

  .motion-video {
    width: 100%;
  }
`;
const S = {
  Section,
  Background,
  Wrapper,
  ScrollBlock,
  TextWrapper,
  StickyImageWrapper,
};

export default S;
